import { ValidationErrors, UntypedFormGroup } from '@angular/forms';

export const linkValidator: Function = () => {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    if (control) {
      let isValidValue = false;
      let regexExp =
        /^([hH][tT]{2}[pP][sS]?:\/\/)?\w+([-.]\w+)*\.[a-zA-Z]{2,5}(:\d{1,5})?(\/[^\s]*)?$/;
      isValidValue = regexExp.test(control.value); //verify URL
      if (!isValidValue) {
        regexExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //verify email
        isValidValue = regexExp.test(control.value);
      }
      return !isValidValue ? { link: { value: control.value } } : null;
    }

    return null;
  };
};
